import React, { useCallback } from 'react';
import styles from './IconButton.module.scss';

function IconButton(props) {
    const { className = '', children, onClick, href, target , primary, secondary} = props;

    const handleClick = useCallback(() => {
        if (href) {
            if (target || href.indexOf(location.origin) === -1) {
                window.open(href, target || '_blank');
            } else {
                app.history.push(href);
            }
        }
        if (onClick) {
            onClick();
        }
    }, [onClick, href, target]);

    return (
        <button type="button" className={[className, styles.IconButton, primary ? styles.primary : '', secondary ? styles.secondary : ''].join(' ')} onClick={handleClick}>
            {children}
        </button>
    );
}

export default IconButton;
